<div class="modal-content offer-password-dialog">
  <div class="modal-header">
    <p class="modal-title"><strong>{{ getTitleKey() | translate }}</strong></p>
    <button type="button" class="close" (click)="dialogRef.close()" [disabled]="submitting">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form (ngSubmit)="submit()" novalidate>
    <div class="modal-body">
      <mat-dialog-content style="overflow: visible">
        <p class="offer-password-dialog__message">
          {{ getDescriptionKey() | translate }}
        </p>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'LOGIN_COMPONENT_PASSWORD' | translate }}</mat-label>
          <input matInput [(ngModel)]="password" name="password" type="password" required
                 autocomplete="current-password" [errorStateMatcher]="matcher" />
          <!-- Material Error Component -->
        </mat-form-field>

        <small class="text-center d-block mt-2"
               [innerHTML]="'REGISTER_RECAPTCHA_DISCLAIMER' | translate"></small>
      </mat-dialog-content>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary-green" [disabled]="submitting">
        {{ 'COMMON_BUTTON_CONTINUE' | translate }}
      </button>
    </div>
  </form>
</div>
